import React, { Component } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'

import './Orchestras.css'
import classNames from './Orchestras.css'
import { picassoFetch } from '../utils/fetch'
import { userHasPerm } from '../utils/auth'
import { createImageGetter } from '../utils/images'
import { fetchQueues } from '../redux/queues'
import LoadingSpinner from '../components/LoadingSpinner'
import ErrorMessage from '../components/ErrorMessage'
import OrchestraArrange from '../components/orchestra/OrchestraArrange'
import OrchestraPreferences from '../components/orchestra/OrchestraPreferences'
import { ORCHESTRA_SOCKET, ENDPOINT_ORCHESTRA_TOKEN } from '../constants'
import mousetrap from 'mousetrap'

const SCENE_TYPES = ['Floating', 'Ken Burns']

class Orchestras extends Component {
  state = {
    channels: null,
    channelsError: null,
    shareChannel: null,
    usersChecked: null,
    renameChannel: null,
    editChannelQueue: null,
    fetching: false,
    showCreateChannelModal: false,
    showInfo: null,
    addingQueueToChannel: false,
    formation: null,
    scenePreferences: {},
    orchestraPreferences: { 'scene_type': SCENE_TYPES[0] },
    selectedPlayerId: null
  }
  log = (message, source = 'frontend') => {
    // if (this.mounted) {
    //   console.log(source, message)
    //   this.setState({
    //     logs: this.state.logs.concat({ message, source })
    //   })
    // }
  }
  componentDidMount() {
    this.mounted = true;
    const { channels } = this.state
    if (!channels) {
      this.fetchChannels()
    }
    this.openSocket();

    // set up key handling
    mousetrap.bind('d', this.onKeyRemove)
    mousetrap.bind('i', this.onKeyIdentify)
  }
  onKeyRemove = e => {
    e.preventDefault()
    let playerId = this.state.selectedPlayerId;

    // bail if no player is selected
    if (playerId == null || playerId == '') {
      return;
    }

    // only remove inactive players
    if (this.playerActive(playerId)) {
      window.alert('You can only delete inactive players!')
      return;
    }

    this.wsSendRemovePlayer(playerId);
    this.setState({
      selectedPlayerId: null
    });
  }
  playerActive = playerId => {
    let player = this.playerForId(playerId);
    return player && player.connected;
  }
  playerForId = playerId => {
    var match;
    this.state.formation.players.forEach((player) => {
      if (player.id == playerId) {
        match = player;
      }
    });

    return match;
  }
  onKeyIdentify = e => {
    e.preventDefault()
    console.log('IDENTIFY')

    let playerId = this.state.selectedPlayerId
    if (this.playerActive(playerId)) {
      this.identifyPlayer(playerId)
    }
  }
  fetchChannels = () => {
    this.setState({
      channelsError: null,
      fetching: true
    })
    this.props.fetchChannels(this.props.dispatch).then(data => {
      this.setState({
        channels: data.channels,
        fetching: false
      })
    }, e => {
      this.setState({
        channelsError: e,
        fetching: false
      })
    })
  }
  fetchOrchestras = () => {
    // just get the one for the time being
  }
  openSocket = auth => {
    this.log('Connecting to websocket');
    this.ws = new window.WebSocket(this.props.route.socket);
    this.ws.onopen = () => {
      this.log('Socket open, saying hello!');
      this.wsSayHello();
    };
    this.ws.onmessage = this.wsHandleMessage
    this.ws.onclose = e => {
      this.log('Socket closed');
      if (this.mounted) {
        this.setState({ showDebug: true });
        this.setState({ orchestraName: null, formation: null });
        setTimeout(() => {
          this.openSocket();
        }, 1000);
      }
    }
    this.ws.onerror = e => {
      this.log('Socket error')
      if (this.mounted) {
        this.setState({ showDebug: true });
      }
    }
    window.ws = this.ws // TMP
  }
  wsSayHello = () => {
    this.wsSendMessage({
      topic: 'hello'
    });
  }
  onFormationChange = (formation) => {
    this.setState({ formation: formation });
    this.wsSendFormationUpdate(formation);
  }
  wsSendFormationUpdate = (formation) => {
    this.wsSendMessage({
      topic: 'reposition',
      data: formation
    });
  }
  identifyPlayer = (playerId) => {
    this.wsSendMessage({
      topic: 'identify',
      data: {
        scene_id: 0,
        player_id: playerId
      }
    });
  }
  onPlayerClicked = (playerId) => {
    this.setState({
      selectedPlayerId: playerId
    });
  }
  wsSendRemovePlayer = (playerId) => {
    this.wsSendMessage({
      topic: 'remove-player',
      data: {
        player_id: playerId
      }
    })
  }
  wsSendShrinkWrap = () => {
    this.wsSendMessage({
      topic: 'shrinkwrap',
      data: {
        scene_id: 0
      }
    });
  }
  wsSendScenePrefsUpdate = (prefs) => {
    // get preference values without metadata
    const slimPrefs = {};
    for (let [key, value] of Object.entries(prefs)) { slimPrefs[key] = value.value; }
    // send to server
    this.wsSendMessage({
      topic: 'adjust-scene-preferences',
      data: {
        scene_id: 0,
        preferences: slimPrefs
      }
    });
  }
  wsSendOrchestraPrefsUpdate = () => {
    this.wsSendMessage({
      topic: 'adjust-orchestra-preferences',
      data: {
        orchestra_id: 0,
        preferences: this.state.orchestraPreferences
      }
    });
  }
  wsSendMessage = data => {
    data['client'] = 'admin';
    this.ws.send(JSON.stringify(data));
  }
  wsHandleMessage = e => {
    const msg = JSON.parse(e.data);
    if (msg.topic === 'formation') {
      let formation = msg.data;
      let orchPrefs = this.state.orchestraPreferences;
      orchPrefs['scene_type'] = formation.scene_type;
      this.setState({
        formation: formation,
        orchestraName: formation.orchestra_name,
        scenePreferences: formation.scene_preferences,
        orchestraPreferences: orchPrefs
      });
    }
    if (msg.topic == 'orchestra-preferences') {
      this.setState({ 'orchestraPreferences': msg.data });
    }
  }
  updateOrchPref = (key, value) => {
    let { orchestraPreferences } = this.state;
    orchestraPreferences[key] = value;
    this.setState({ orchestraPreferences: orchestraPreferences });
    this.wsSendOrchestraPrefsUpdate();
  }
  render() {
    const { queues, canCreateChannels } = this.props
    const { channels, channelsError, orchestraPreferences, shareChannel, fetching } = this.state
    if (channelsError) {
      return (
        <ErrorMessage
          message='There was an error fetching channels'
          onRetry={this.fetchChannels}
        />
      )
    }
    if (!channels) {
      return (
        <div>
          <h2>Connecting to Picasso...</h2>
          <LoadingSpinner />
        </div>
      )
    }
    return (
      <div className={classNames.page}>
        <span className={classNames.orchestraAdminHelpText}>Click to select Player<br></br>Press 'I' to Identify<br></br>Press 'D' to delete selected Player</span>
        <h1>Installation: {this.state.orchestraName}</h1>
        <div className={classNames.orchestraPageFlexContainer}>
          <div className={classNames.scenePreferencesPanel}>
          <h2>Scene Type</h2>
            <SceneTypePicker
              value={orchestraPreferences.scene_type}
              onChange={value => this.updateOrchPref('scene_type', value)}
            />
            <h2>Scene Preferences</h2>
            <OrchestraPreferences items={this.state.scenePreferences} onPrefChange={this.wsSendScenePrefsUpdate}/>
          </div>

          <div className={classNames.sceneArrangePanel}>
            <OrchestraArrange
              selectedPlayerId={this.state.selectedPlayerId}
              sceneFormation={this.state.formation}
              onFormationChange={this.onFormationChange}
              onPrefChange={this.wsSendScenePrefsUpdate}
              identifyPlayer={this.identifyPlayer}
              onPlayerClicked={this.onPlayerClicked}
              sendShrinkWrap={this.wsSendShrinkWrap}
              onOrchPrefChange={this.wsSendOrchestraPrefsUpdate}
            />
          </div>
        </div>
      </div>
    )
  }
}

function SceneTypePicker ({ value, onChange }) {
  console.log(value);
  var sceneDescripion = '';
  if (value == 'Floating') {
    sceneDescripion = 'Images float across the screen on different layers';
  }
  if (value == 'Ken Burns') {
    sceneDescripion = 'Images fade from one to the next, zooming and panning subtly';
  }
  return (
    <div><div>
      {SCENE_TYPES.map(st => (
        <button
          key={st}
          type='button'
          onClick={() => onChange(st)}
          className={value === st ? classNames.smallButtonActive : classNames.smallButton}>
          {st}
        </button>
      ))}
    </div><div className={classNames.sceneTypeDescription}>
        <p>{sceneDescripion}</p>
      </div></div>
  )
}

const mapStateToProps = ({ queues, entities, auth }) => ({
  entities,
  me: auth.user,
  queues: queues.data && queues.data.map(id => entities.queues[id]),
  canCreateChannels: userHasPerm(auth.user, 'create_channels'),
  fetchQueues: dispatch => dispatch(fetchQueues()),
  fetchChannels: dispatch => picassoFetch(auth, 'list_channels', undefined, dispatch),
  createChannel: (name, queueID) => picassoFetch(auth, 'create_channel', {
    name,
    queue_id: queueID || undefined,
    time_offset: new Date().getTimezoneOffset() * -60
  }),
  deleteChannel: id => picassoFetch(auth, 'remove_channel', { channel_id: id }),
  sendQueueToChannel: (channelID, queueID, position) => picassoFetch(auth, 'set_queue', {
    channel_id: channelID,
    queue_id: queueID,
    location: position.lat ? `${position.lat},${position.lon}` : undefined,
    time_offset: new Date().getTimezoneOffset() * -60
  }),
  renameChannel: (id, name) => picassoFetch(auth, 'rename_channel', {
    channel_id: id,
    name
  }),
  updateChannel: (id, values) => picassoFetch(auth, 'update_channel', {
    channel_id: id,
    update: values
  }),
  channelAction: (id, action, extra) => picassoFetch(auth, action, { channel_id: id, ...extra }),
  channelEvent: (id, event) => picassoFetch(auth, 'send_event', { channel_id: id, event }),
  disableChannel: id => picassoFetch(auth, 'disable_channel', { channel_id: id }),
  enableChannel: id => picassoFetch(auth, 'enable_channel', { channel_id: id }),
  getOwner: channel => entities.users[channel.owner_id],
  getImageSource: createImageGetter(auth)
})

export default connect(mapStateToProps, null)(Orchestras)


// WEBPACK FOOTER //
// ./src/pages/Orchestras.js